import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  DialogCancelButton,
  DialogDestructiveActionButton,
} from "..";

function DeleteDialog({ onClose, onDelete, open, name, resource, ...rest }) {
  const { t } = useTranslation();

  const {
    DialogTitle: CustomDialogTitle,
    DialogContentText: CustomDialogContentText,
    DialogConfirmButton: CustomDialogConfirmButton,
  } = rest;
  return (
    <Dialog {...rest} open={open} onClose={onClose}>
      {CustomDialogTitle ? (
        <CustomDialogTitle />
      ) : (
        <DialogTitle>{t("Delete {{resource}}", { resource })}</DialogTitle>
      )}
      <DialogContent>
        {CustomDialogContentText ? (
          <CustomDialogContentText />
        ) : (
          <DialogContentText>
            {t("Are you sure you would like to delete {{name}}?", {
              name: name ?? t("your {{resource}}", { resource }),
            })}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <DialogCancelButton
          onClick={onClose}
          data-test-id="delete-dialog-close-button"
        >
          {t("Cancel")}
        </DialogCancelButton>
        {CustomDialogConfirmButton ? (
          <CustomDialogConfirmButton />
        ) : (
          <DialogDestructiveActionButton
            onClick={onDelete}
            data-test-id="delete-dialog-delete-button"
          >
            {t("Delete {{resource}}", { resource })}
          </DialogDestructiveActionButton>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default memo(DeleteDialog);
